<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextIdA: String
});

const data = reactive({
  loading: false,
  dataLoading: true,
  search: null,
  newReviewer: false,
  headers: [
    { title: 'Name', key: 'name' },
    { title: 'Actions', key: 'actions' },
  ],
  items: [],
  newId: null,
  names: null
})

const getData = () => {
  ApiWrapper.post('reviewers', 'get-reviewers', {
        clientId: props.contextIdA
      })
      .then((response) => {
        if(response.items){
          data.items = response.items
        }
        if(response.names){
          data.names = response.names
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
}

const addReviewer = () => {
  data.loading = true
  ApiWrapper.post('reviewers', 'new-reviewer', {
        clientId: props.contextIdA,
        id: data.newId,
      })
      .then((response) => {
        getData()
        data.newReviewer = false
        data.newId = null
        data.loading = false
        ToastUtil.successMsg('Assigned new reviewer');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false
      })
}
const removeReviewer = (item) => {
  data.loading = true
  ApiWrapper.post('reviewers', 'remove-reviewer', {
        clientId: props.contextIdA,
        id: item.id,
      })
      .then((response) => {
        getData()
        data.loading = false
        ToastUtil.successMsg('Removed reviewer');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Reviewers</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>

        <v-btn variant="elevated" color="primary" size="small" v-if="Permissions.checkPermissions(['reviewers.new-reviewer'])" @click="data.newReviewer = true">
          New Reviewer
        </v-btn>
      </v-toolbar>
      <v-row v-if="data.newReviewer" class="px-5">
        <v-col cols="12" sm="3">
          <v-autocomplete
              class="px-3"
              v-model="data.newId"
              :items="data.names"
              :rules="[v => !!v || 'A Reviewer is required']"
              label="Type or Select Reviewer's Name"
              clearable
              item-title="name"
              item-value="id"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="4">
          <v-btn
              size="small"
              variant="elevated"
              class="px-2"
              @click="addReviewer()"
              color="primary"
          >
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>
          <v-btn
              size="small"
              variant="elevated"
              class="px-2"
              @click="data.newId=null;data.newReviewer=false"
              color="error"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-text-field
            v-model="data.search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="px-10"
        ></v-text-field>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.name`]="{ item }">
          <RouterLink :to="`/userprofile/${item.id}`">
            {{ item.name }}
          </RouterLink>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-if="Permissions.checkPermissions(['reviewers.remove-reviewer'])" @click="removeReviewer(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }
  [v-cloak] {
    display: none;
  }
</style>